// 9fbef606107a605d69c0edbcd8029e5d

const getAppliedFilters = (initialValues = {}, filtersMaps) => {
  const appliedFilters = [];
  // eslint-disable-next-line
  for (const k in initialValues) {
    if (k === 'min_offer_price' && initialValues[k]?.length > 0) {
      const selectedFacet = {
        id: initialValues[k][0],
        displayName: initialValues[k][0],
        facetName: k,
      };
      const list = [];
      list.push(selectedFacet);
      appliedFilters.push(list);
    } else {
      const selectedFacet = filtersMaps[k]
        ? initialValues[k].map((filterId) =>
            filtersMaps[k].find((filter) => filterId === filter.id)
          )
        : null;

      if (selectedFacet) {
        appliedFilters.push(selectedFacet);
      }
    }
  }
  return appliedFilters;
};

// eslint-disable-next-line import/prefer-default-export
export { getAppliedFilters };
